/* eslint-disable no-underscore-dangle */
import consumer from 'channels/consumer';
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static values = { channel: String, id: String };

  // Subscribes on connect and unsubscribes on disconnect: the ActionCable consumer outlives the
  // page under Turbo Drive, so a subscription made once per controller instance and never dropped
  // would keep receiving (and alerting on) broadcasts after the user navigated away.
  connect() {
    this.subscription = consumer.subscriptions.create(
      {
        channel: this.channelValue,
        id: this.idValue,
      },
      {
        connected: this._connected.bind(this),
        disconnected: this._disconnected.bind(this),
        received: this.received.bind(this),
      }
    );
  }

  disconnect() {
    this.subscription?.unsubscribe();
    this.subscription = null;
  }

  _connected() {}

  _disconnected() {}

  received(data) {
    if (data.status === 'success') {
      this.dispatch('received');
    } else {
      alert('Unable to process activity list. Please update and try again.');
    }
  }
}
